<template>
  <el-container style="height: 100%">
    <el-header style="height: auto;">
      <el-form label-position="left" size="small" inline>
        <el-form-item style="padding-right: 10px">
          <el-button @click="$router.go(-1)" icon="el-icon-arrow-left">返回</el-button>
        </el-form-item>
        <el-form-item label="类别：">
          <el-radio-group v-model="params.hospitalized">
            <el-radio :label="null">全部</el-radio>
            <el-radio :label="1">住院</el-radio>
            <el-radio :label="0">门诊</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="统计期间：" style="padding-left: 20px">
          <el-date-picker
            style="width: 220px;"
            v-model="dateScope"
            type="daterange"
            format="yyyy/MM/dd"
            value-format="timestamp"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            range-separator="~"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button :loading="exportLoading" @click="exportFollowUpCount" type="success"><i class="fas fa-file-export" style="margin-right: 5px"></i>导出</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main>
      <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="p20-scrollbar__view">
        <el-table
          v-loading="loading"
          :data="tableData"
          :cell-style="columnStyle"
          :summary-method="getSummaries"
          show-summary
          style="width: 100%">
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column label="随访科室" prop="oname"></el-table-column>
          <el-table-column label="计划随访量" prop="total"></el-table-column>
          <el-table-column label="实际随访数量" prop="finishs"></el-table-column>
          <el-table-column label="执行率" :formatter="formatter" prop="finishRate"></el-table-column>
          <el-table-column label="良好数" prop="wells"></el-table-column>
          <el-table-column label="良好率" :formatter="formatter" prop="wellRate"></el-table-column>
          <el-table-column prop="fails">
            <template slot="header">
              <label style="color: #ff0000">不良数</label>
            </template>
            <template slot-scope="scope">
              <a href="javascript:void(0);" @click="handlerClickfail(scope.row)" style="text-decoration: underline; color: #ff0000;"> {{ scope.row.fails }} </a>
            </template>
          </el-table-column>
          <el-table-column prop="failRate" :formatter="formatter">
            <template slot="header">
              <label style="color: #ff0000">不良率</label>
            </template>
          </el-table-column>
          <el-table-column label="无效随访数" prop="invalids"></el-table-column>
          <el-table-column prop="planLeave" :formatter="formatter">
            <template slot="header">
              <label>随访计划率</label>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </el-main>
<!--    <el-dialog title="不良随访列表" :visible.sync="visibleFail" width="1300px" slot="title">-->
    <el-dialog :visible.sync="visibleFail" width="1300px">
      <template slot="title">
        <div>
          <span style="line-height: 24px; font-size: 18px; color: #303133;">不良随访列表</span>
          <el-button style="float: right; margin-right: 50px;" @click="exportFollowUpCountFailure" type="info" size="mini">
            <i class="fas fa-file-export" style="margin-right: 5px"></i>
            导出
          </el-button>
        </div>
      </template>
      <list :showHeader="false" :params="failParams" style="height: 500px"></list>
    </el-dialog>
  </el-container>
</template>

<script>
  import moment from 'moment'
  import _ from 'lodash'
  import FollowupCountService from '@/request/count/followup'
  import FollowupService from '@/request/followup/followup'
  import OrgService from '@/request/user/org'
  import List from "./list";
  import FileSaver from 'file-saver'
  import XLSX from 'xlsx'
  export default {
    name: "FollowupCount",
    components: {List},
    data () {
      return {
        dateScope: [],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = moment().endOf('day').valueOf()
              const start = end - 3600 * 1000 * 24 * 7
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '本月',
            onClick (picker) {
              const end = moment().endOf('day').valueOf()
              const start = moment().startOf('month').valueOf()
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = moment().endOf('day').valueOf()
              const start = end - 3600 * 1000 * 24 * 30
              picker.$emit('pick', [start, end])
            }
          }]
        },
        params: {
          hospitalized: null,
          oids: null,
          start: moment().subtract(1, 'day').startOf().valueOf(),
          end: moment().endOf('day').valueOf()
        },
        tableData: [],
        visibleFail: false,
        failParams: null,
        loading: false,
        exportLoading: false,
        recordAll: 0,
        haveFollowup: 0,
      }
    },
    watch: {
      params: {
        deep: true,
        handler () {
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            this.loadData()
          }, 200)
        }
      },
      dateScope () {
        _.extend(this.params, {
          start: this.dateScope ? moment(this.dateScope[0]).startOf('d').valueOf() || null : null,
          end: this.dateScope ? moment(this.dateScope[1]).endOf('d').valueOf() || null : null
        })
      },
    },
    created() {
      this.initDateScope()
      this.loading = true
      let hid = this.$route.params.hid
      if (hid) {
        this.loadOrg(hid)
      }
    },
    methods: {
      initDateScope() {
        this.dateScope = [moment().subtract(7, 'd').startOf('d').valueOf(), moment().endOf('d').valueOf()]
      },
      loadOrg (hid) {
        if (hid) {
          OrgService.listOrg({pids: hid}).then(res => {
            let oids = []
            _.forEach(res.result || [], val => {
              oids.push(val.id)
            })
            this.params.oids = oids.toString()
          }).catch(() => {
            this.loading = false
          })
        }
      },
      loadData () {
        this.loading = true
        let tableData = []
        const _params = _.clone(this.params)
        FollowupCountService.volumeCountOrg(_params).then(res => {
          const result = res.result || []
          tableData = _.forEach(result || [], val => {
            // 执行率：（实际随访数量/待执行随访数量）*100%。
            const _finishRate =  val.finishs / val.total
            val.finishRate = isNaN(_finishRate) ? 0: _finishRate * 100
            // 良好率：：（回访良好数/实际随访数量）*100%。
            const _wellRate = val.wells / val.finishs
            val.wellRate = isNaN(_wellRate) ? 0: _wellRate * 100
            // 不良率：（回访不良数/实际随访数量）*100%。
            const _failRate = val.fails / val.finishs
            val.failRate = isNaN(_failRate) ? 0 : _failRate * 100
          })
          FollowupCountService.countOrg(_params).then(res => {
            let haveFollowup = 0
            let recordAll = 0
            _.forEach(res.result || [], val1 => {
              haveFollowup = haveFollowup + val1.already;
              recordAll = recordAll + val1.total;
              _.forEach(tableData, val2 => {
                if (val1.oid === val2.oid) {
                  if (val1.already) {
                    val2.planLeave = (isNaN(val1.already / val1.total) ? 0: val1.already / val1.total *100)
                  } else {
                    val2.planLeave = 0
                  }
                }
              })
            })
            this.tableData = tableData;
            this.recordAll = recordAll;
            this.haveFollowup = haveFollowup;
          })
        }).finally(() => {
          this.loading = false
        })
      },
      handlerClickfail (row) {
        const _failParams = {};
        _failParams.start = row.start
        _failParams.end = row.end
        _failParams.oids = row.oid
        _failParams.hids = row.pid
        _failParams.failure = 1
        this.failParams = _failParams
        this.visibleFail = true
      },
      columnStyle (param) {
        if (param.columnIndex === 8) {
          return {color: '#ff0000'}
        }
      },
      formatter(row, column) {
        if (column.property === 'finishRate') {
          return row.finishRate.toFixed(2) + '%'
        }
        if (column.property === 'wellRate') {
          return row.wellRate.toFixed(2) + '%'
        }
        if (column.property === 'failRate') {
          return row.failRate.toFixed(2) + '%'
        }
        if (column.property === 'planLeave') {
          return row.planLeave.toFixed(2) + '%'
        }
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          if (index === 1) {
            return
          }
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0);
            if (column.property === 'finishRate') {
              const finishRate = (sums[3] / sums[2] * 100)
              sums[index] = isNaN(finishRate) ? '0.00%' : finishRate.toFixed(2) + '%'
            }
            if (column.property === 'wellRate') {
              const wellRate = (sums[5] / sums[3] * 100)
              sums[index] = isNaN(wellRate) ? '0.00%' : wellRate.toFixed(2) + '%'
            }
            if (column.property === 'failRate') {
              const failRate = (sums[7] / sums[3] * 100)
              sums[index] = isNaN(failRate) ? '0.00%' : failRate.toFixed(2) + '%'
            }
            if (column.property === 'planLeave') {
              const planLeave = (this.haveFollowup / this.recordAll * 100)
              sums[index] = isNaN(planLeave) ? '0.00%' : planLeave.toFixed(2) + '%'
            }
          } else {
            sums[index] = 'N/A'
          }
        })
        return sums;
      },
      exportFollowUpCount () {
        this.exportLoading = true
        /* generate workbook object from table */
        //表名
        var wb = XLSX.utils.table_to_book(document.querySelector('.el-table'), { raw: true })
        /* get binary string as output */
        var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        try {
          FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '随访统计.xlsx')
          this.exportLoading = false
        } catch (e) {
          if (typeof console !== 'undefined')
          console.log(e, wbout)
          this.exportLoading = false
        }
        return wbout
        // FollowupCountService.exportVolumeCount(this.params)
      },
      exportFollowUpCountFailure() {
        console.log('下载文件')
        console.log(this.failParams);
        // const _failParams = _.clone(this.failParams)
        FollowupService.export(this.failParams)
      }
    }
  }
</script>

<style scoped>

</style>
